import { render } from "./stronaPodgladuBody.vue?vue&type=template&id=85070de2&scoped=true"
import script from "./stronaPodgladuBody.vue?vue&type=script&lang=js"
export * from "./stronaPodgladuBody.vue?vue&type=script&lang=js"

import "./stronaPodgladuBody.vue?vue&type=style&index=0&id=85070de2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85070de2"]])

export default __exports__